export { default, getStaticProps } from "app/ecologie-location-telephone/page";
